export class InventoryTypeMessage { 
  displayOrder: number
  name: string

  constructor(displayOrder: number, name: string) {
    this.displayOrder = displayOrder
    this.name = name
  }
}
  